import { Machine, sendParent, send, assign } from "xstate";

function isNumber(value) {
  return !Number.isNaN(Number(value));
}
const description = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isDescriptionEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const locationDifferent = {
  initial: "noError",
  states: {
    noError: {
      initial: "unset",
      on: {
        INIT: [
          {
            cond: context => {
              return context.locationDifferent === "yes";
            },
            target: "#step4.ready.locationDifferent.noError.yes"
          },
          {
            cond: context => {
              return context.locationDifferent === "no";
            },
            target: "#step4.ready.locationDifferent.noError.no"
          }
        ],
        SUBMIT: [
          {
            cond: "isLocationDifferentEmpty",
            target: "error.empty"
          }
        ]
      },
      states: {
        unset: {},
        yes: {},
        no: {}
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const locationDifferentConfig = {
  id: "locationDifferent",
  initial: "noError",
  context: {
    value: ""
  },
  states: {
    noError: {
      initial: "unset",
      on: {
        SUBMIT: [{ cond: "isLocationDifferentEmpty", target: "error.empty" }]
      }
    }
  }
};

const streetAddress = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isStreetAddressEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const streetAddress2 = {
  initial: "noError",
  states: {
    noError: {}
  }
};

const state = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isStateEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const city = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isCityEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const postalCode = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isPostalCodeEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const hasLien = {
  initial: "noError",
  states: {
    noError: {
      initial: "unset",
      on: {
        INIT: [
          {
            cond: context => {
              return context.hasLien === "yes";
            },
            target: "#step4.ready.hasLien.noError.yes"
          },
          {
            cond: context => {
              return context.hasLien !== "yes";
            },
            target: "#step4.ready.hasLien.noError.no"
          }
        ],
        SUBMIT: [
          {
            cond: "isHasLienEmpty",
            target: "error.empty"
          }
        ]
      },
      states: {
        unset: {},
        yes: {},
        no: {}
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const lienHolderName = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isLienHolderNameEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const lienHolderContact = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isLienHolderContactEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const lienPayoutAmount = {
  initial: "noError",
  states: {
    noError: {}
  }
};

const requiresDismantling = {
  initial: "noError",
  states: {
    noError: {
      initial: "unset",
      on: {
        INIT: [
          {
            cond: context => {
              return context.requiresDismantling === "yes";
            },
            target: "#step4.ready.requiresDismantling.noError.yes"
          },
          {
            cond: context => {
              return context.requiresDismantling !== "yes";
            },
            target: "#step4.ready.requiresDismantling.noError.no"
          }
        ],
        SUBMIT: [
          {
            cond: "isRequiresDismantlingEmpty",
            target: "error.empty"
          }
        ]
      },
      states: {
        unset: {},
        yes: {},
        no: {}
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const dismantleDays = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isDismantleDaysEmpty",
            target: "error.empty"
          },
          {
            cond: "isDismantleDaysValid",
            target: "error.invalid"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {},
        invalid: {}
      }
    }
  }
};

const willHelpDismantle = {
  initial: "noError",
  states: {
    noError: {
      initial: "unset",
      on: {
        INIT: [
          {
            cond: context => {
              return context.willHelpDismantle === "yes";
            },
            target: "#step4.ready.willHelpDismantle.noError.yes"
          },
          {
            cond: context => {
              return context.willHelpDismantle !== "yes";
            },
            target: "#step4.ready.willHelpDismantle.noError.no"
          }
        ],
        SUBMIT: [
          {
            cond: "isWillHelpDismantleEmpty",
            target: "error.empty"
          }
        ]
      },
      states: {
        unset: {},
        yes: {},
        no: {}
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const dismantleHelpDescription = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isDismantleHelpDescriptionEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const providesDisconnect = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isProvidesDisconnectEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const requiresCrane = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isRequiresCraneEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const numberOfTrucks = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isNumberOfTrucksEmpty",
            target: "error.empty"
          },
          {
            cond: "isNumberOfTrucksValid",
            target: "error.invalid"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {},
        invalid: {}
      }
    }
  }
};

const loadingEquipmentDescription = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "loadingEquipmentDescriptionEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const requiresLoading = {
  initial: "noError",
  states: {
    noError: {
      initial: "unset",
      on: {
        INIT: [
          {
            cond: context => {
              return context.requiresLoading === "yes";
            },
            target: "#step4.ready.requiresLoading.noError.yes"
          },
          {
            cond: context => {
              return context.requiresLoading !== "yes";
            },
            target: "#step4.ready.requiresLoading.noError.no"
          }
        ],
        SUBMIT: [
          {
            cond: "isRequiresLoadingEmpty",
            target: "error.empty"
          }
        ]
      },
      states: {
        unset: {},
        yes: {},
        no: {}
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const willLoadEquipment = {
  initial: "noError",
  states: {
    noError: {
      initial: "unset",
      on: {
        INIT: [
          {
            cond: context => {
              return context.willLoadEquipment === "yes";
            },
            target: "#step4.ready.willLoadEquipment.noError.yes"
          },
          {
            cond: context => {
              return context.willLoadEquipment === "no";
            },
            target: "#step4.ready.willLoadEquipment.noError.no"
          }
        ],
        SUBMIT: [
          {
            cond: "isWillLoadEquipmentEmpty",
            target: "error.empty"
          }
        ]
      },
      states: {
        unset: {},
        yes: {},
        no: {}
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const hasLoadingEquipment = {
  initial: "noError",
  states: {
    noError: {
      initial: "unset",
      on: {
        INIT: [
          {
            cond: context => {
              return context.hasLoadingEquipment === "yes";
            },
            target: "#step4.ready.hasLoadingEquipment.noError.yes"
          },
          {
            cond: context => {
              return context.hasLoadingEquipment === "no";
            },
            target: "#step4.ready.hasLoadingEquipment.noError.no"
          }
        ],
        SUBMIT: [
          {
            cond: "isHasLoadingEquipmentEmpty",
            target: "error.empty"
          }
        ]
      },
      states: {
        unset: {},
        yes: {},
        no: {}
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

export const getStep4 = values => {
  const defaultValues = {
    description: "",
    locationDifferent: undefined,
    streetAddress: "",
    streetAddress2: "",
    state: "",
    city: "",
    postalCode: undefined,
    hasLien: undefined,
    lienHolderName: "",
    lienHolderContact: "",
    lienPayoutAmount: undefined,
    requiresDismantling: undefined,
    dismantleDays: undefined,
    willHelpDismantle: undefined,
    dismantleHelpDescription: "",
    providesDisconnect: undefined,
    requiresCrane: undefined,
    numberOfTrucks: undefined,
    requiresLoading: undefined,
    willLoadEquipment: undefined,
    hasLoadingEquipment: undefined,
    loadingEquipmentDescription: ""
  };
  const config: any = {
    id: "step4",
    initial: "ready",
    context: {
      ...defaultValues,
      ...values
    },
    states: {
      ready: {
        type: "parallel",
        on: {
          INPUT_DESCRIPTION: {
            actions: "setDescription",
            target: ".description.noError"
          },
          INPUT_LOCATION_DIFFERENT: [
            {
              cond: "didSelectLocationDifferentYes",
              actions: "setLocationDifferent",
              target: [
                "ready.locationDifferent.noError.yes",
                "ready.streetAddress.noError",
                "ready.streetAddress2.noError",
                "ready.state.noError",
                "ready.city.noError",
                "ready.postalCode.noError"
              ]
            },
            {
              cond: "didSelectLocationDifferentNo",
              actions: "setLocationDifferent",
              target: [
                "ready.locationDifferent.noError.no",
                "ready.streetAddress.noError",
                "ready.streetAddress2.noError",
                "ready.state.noError",
                "ready.city.noError",
                "ready.postalCode.noError"
              ]
            }
          ],
          INPUT_STREET_ADDRESS: {
            actions: "setStreetAddress",
            target: "ready.streetAddress.noError"
          },
          INPUT_STREET_ADDRESS2: {
            actions: "setStreetAddress2",
            target: "ready.streetAddress2.noError"
          },
          INPUT_STATE: {
            actions: "setState",
            target: "ready.state.noError"
          },
          INPUT_CITY: {
            actions: "setCity",
            target: "ready.city.noError"
          },
          INPUT_POSTAL_CODE: {
            actions: "setPostalCode",
            target: "ready.postalCode.noError"
          },
          INPUT_HAS_LIEN: [
            {
              cond: (context, event) => {
                return event.hasLien === "yes";
              },
              actions: "setHasLien",
              target: [
                "ready.hasLien.noError.yes",
                "ready.lienHolderName.noError",
                "ready.lienPayoutAmount.noError",
                "ready.lienHolderContact.noError"
              ]
            },
            {
              cond: (context, event) => {
                return event.hasLien !== "yes";
              },
              actions: "setHasLien",
              target: [
                "ready.hasLien.noError.no",
                "ready.lienHolderName.noError",
                "ready.lienPayoutAmount.noError",
                "ready.lienHolderContact.noError"
              ]
            },
            {
              cond: (context, event) => {
                return event.hasLien !== "no";
              },
              target: "ready.lienHolderName.noError"
            },
            {
              cond: (context, event) => {
                return event.hasLien !== "no";
              },
              target: "ready.lienHolderContact.noError"
            },
            {
              cond: (context, event) => {
                return event.hasLien !== "no";
              },
              target: "ready.lienPayoutAmount.noError"
            }
          ],
          INPUT_LIEN_HOLDER_NAME: {
            actions: "setLienHolderName",
            target: "ready.lienHolderName.noError"
          },
          INPUT_LIEN_HOLDER_CONTACT: {
            actions: "setLienHolderContact",
            target: "ready.lienHolderContact.noError"
          },
          INPUT_LIEN_PAYOUT_AMOUNT: {
            actions: "setLienPayoutAmount",
            target: "ready.lienPayoutAmount.noError"
          },
          INPUT_REQUIRES_DISMANTLING: [
            {
              cond: (context, event) => {
                return event.requiresDismantling === "yes";
              },
              actions: "setRequiresDismantling",
              target: "ready.requiresDismantling.noError.yes"
            },
            {
              cond: (context, event) => {
                return event.requiresDismantling !== "yes";
              },
              actions: "setRequiresDismantling",
              target: [
                "ready.requiresDismantling.noError.no",
                "ready.dismantleDays.noError",
                "ready.willHelpDismantle.noError",
                "ready.dismantleHelpDescription.noError",
                "ready.requiresCrane.noError"
              ]
            }
          ],
          INPUT_DISMANTLE_DAYS: {
            actions: "setDismantleDays",
            target: "ready.dismantleDays.noError"
          },
          INPUT_WILL_HELP_DISMANTLE: [
            {
              cond: (context, event) => {
                return event.willHelpDismantle === "yes";
              },
              actions: "setWillHelpDismantle",
              target: "ready.willHelpDismantle.noError.yes"
            },
            {
              cond: (context, event) => {
                return event.willHelpDismantle !== "yes";
              },
              actions: "setWillHelpDismantle",
              target: [
                "ready.willHelpDismantle.noError.no",
                "ready.dismantleHelpDescription.noError"
              ]
            }
          ],
          INPUT_DISMANTLE_HELP_DESCRIPTION: {
            actions: "setDismantleHelpDescription",
            target: "ready.dismantleHelpDescription.noError"
          },
          INPUT_PROVIDES_DISCONNECT: {
            actions: "setProvidesDisconnect",
            target: "ready.providesDisconnect.noError"
          },
          INPUT_REQUIRES_CRANE: {
            actions: "setRequiresCrane",
            target: "ready.requiresCrane.noError"
          },
          INPUT_NUMBER_OF_TRUCKS: {
            actions: "setNumberOfTrucks",
            target: "ready.numberOfTrucks.noError"
          },
          INPUT_REQUIRES_LOADING: [
            {
              cond: (context, event) => {
                return event.requiresLoading === "yes";
              },
              actions: "setRequiresLoading",
              target: "ready.requiresLoading.noError.yes"
            },
            {
              cond: (context, event) => {
                return event.requiresLoading !== "yes";
              },
              actions: "setRequiresLoading",
              target: [
                "ready.requiresLoading.noError.no",
                "ready.numberOfTrucks.noError",
                "ready.willLoadEquipment.noError",
                "ready.hasLoadingEquipment.noError",
                "ready.loadingEquipmentDescription.noError"
              ]
            }
          ],
          INPUT_WILL_LOAD_EQUIPMENT: [
            {
              cond: (context, event) => {
                return event.willLoadEquipment === "yes";
              },
              actions: "setWillLoadEquipment",
              target: "ready.willLoadEquipment.noError.yes"
            },
            {
              cond: (context, event) => {
                return event.willLoadEquipment !== "yes";
              },
              actions: "setWillLoadEquipment",
              target: "ready.willLoadEquipment.noError.no"
            }
          ],
          INPUT_HAS_LOADING_EQUIPMENT: [
            {
              cond: (context, event) => {
                return event.hasLoadingEquipment === "yes";
              },
              actions: "setHasLoadingEquipment",
              target: "ready.hasLoadingEquipment.noError.yes"
            },
            {
              cond: (context, event) => {
                return event.hasLoadingEquipment !== "yes";
              },
              actions: "setHasLoadingEquipment",
              target: "ready.hasLoadingEquipment.noError.no"
            }
          ],
          INPUT_LOADING_EQUIPMENT_DESCRIPTION: {
            actions: "setLoadingEquipmentDescription",
            target: "ready.loadingEquipmentDescription.noError"
          },
          SUBMIT: {
            cond: (_0, _1, meta) => {
              if (
                meta.state.matches("ready.description.error") ||
                meta.state.matches("ready.locationDifferent.error") ||
                meta.state.matches("ready.streetAddress.error") ||
                meta.state.matches("ready.state.error") ||
                meta.state.matches("ready.city.error") ||
                meta.state.matches("ready.postalCode.error") ||
                meta.state.matches("ready.hasLien.error") ||
                meta.state.matches("ready.lienHolderName.error") ||
                meta.state.matches("ready.lienHolderContact.error") ||
                meta.state.matches("ready.requiresDismantling.error") ||
                meta.state.matches("ready.dismantleDays.error") ||
                meta.state.matches("ready.willHelpDismantle.error") ||
                meta.state.matches("ready.dismantleHelpDescription.error") ||
                meta.state.matches("ready.providesDisconnect.error") ||
                meta.state.matches("ready.requiresCrane.error") ||
                meta.state.matches("ready.numberOfTrucks.error") ||
                meta.state.matches("ready.requiresLoading.error") ||
                meta.state.matches("ready.willLoadEquipment.error") ||
                meta.state.matches("ready.hasLoadingEquipment.error")
              ) {
                return false;
              }

              return true;
            },

            target: "finished"
          }
        },
        states: {
          description: {
            ...description
          },
          locationDifferent: {
            ...locationDifferent
          },
          streetAddress: {
            ...streetAddress
          },
          streetAddress2: {
            ...streetAddress2
          },
          state: {
            ...state
          },
          city: {
            ...city
          },
          postalCode: {
            ...postalCode
          },
          hasLien: {
            ...hasLien
          },
          lienHolderName: {
            ...lienHolderName
          },
          lienHolderContact: {
            ...lienHolderContact
          },
          lienPayoutAmount: {
            ...lienPayoutAmount
          },
          requiresDismantling: {
            ...requiresDismantling
          },
          dismantleDays: {
            ...dismantleDays
          },
          willHelpDismantle: {
            ...willHelpDismantle
          },
          dismantleHelpDescription: {
            ...dismantleHelpDescription
          },
          providesDisconnect: {
            ...providesDisconnect
          },
          requiresCrane: {
            ...requiresCrane
          },
          numberOfTrucks: {
            ...numberOfTrucks
          },
          requiresLoading: {
            ...requiresLoading
          },
          willLoadEquipment: {
            ...willLoadEquipment
          },
          hasLoadingEquipment: {
            ...hasLoadingEquipment
          },
          loadingEquipmentDescription: {
            ...loadingEquipmentDescription
          }
        }
      },
      finished: {
        type: "final"
      },
      error: {
        description: {
          ...description
        },
        locationDifferent: {
          ...locationDifferent
        },
        streetAddress: {
          ...streetAddress
        },
        streetAddress2: {
          ...streetAddress2
        },
        state: {
          ...state
        },
        city: {
          ...city
        },
        postalCode: {
          ...postalCode
        },
        hasLien: {
          ...hasLien
        },
        lienHolderName: {
          ...lienHolderName
        },
        lienHolderContact: {
          ...lienHolderContact
        },
        lienPayoutAmount: {
          lienPayoutAmount
        },
        requiresDismantling: {
          ...requiresDismantling
        },
        dismantleDays: {
          ...dismantleDays
        },
        willHelpDismantle: {
          ...willHelpDismantle
        },
        dismantleHelpDescription: {
          ...dismantleHelpDescription
        },
        providesDisconnect: {
          ...providesDisconnect
        },
        requiresCrane: {
          ...requiresCrane
        },
        numberOfTrucks: {
          ...numberOfTrucks
        },
        requiresLoading: {
          ...requiresLoading
        },
        willLoadEquipment: {
          ...willLoadEquipment
        },
        hasLoadingEquipment: {
          ...hasLoadingEquipment
        },
        loadingEquipmentDescription: {
          ...loadingEquipmentDescription
        }
      }
    }
  };

  function isEmpty(someString: string) {
    if (!someString || someString.length === 0) {
      return true;
    }

    return false;
  }

  const guardEmpty = property => (context: any, event: any) => {
    return isEmpty(context[property]);
  };

  const setProperty = (property: string) =>
    assign((context: any, event: any) => {
      return {
        [property]: event[property]
      };
    });

  const step4 = Machine(config, {
    actions: {
      setDescription: setProperty("description"),
      setLocationDifferent: setProperty("locationDifferent"),
      setStreetAddress: setProperty("streetAddress"),
      setStreetAddress2: setProperty("streetAddress2"),
      setState: setProperty("state"),
      setCity: setProperty("city"),
      setPostalCode: setProperty("postalCode"),
      setHasLien: setProperty("hasLien"),
      setLienHolderName: setProperty("lienHolderName"),
      setLienHolderContact: setProperty("lienHolderContact"),
      setLienPayoutAmount: setProperty("lienPayoutAmount"),
      setRequiresDismantling: setProperty("requiresDismantling"),
      setDismantleDays: setProperty("dismantleDays"),
      setWillHelpDismantle: setProperty("willHelpDismantle"),
      setDismantleHelpDescription: setProperty("dismantleHelpDescription"),
      setProvidesDisconnect: setProperty("providesDisconnect"),
      setRequiresCrane: setProperty("requiresCrane"),
      setNumberOfTrucks: setProperty("numberOfTrucks"),
      setRequiresLoading: setProperty("requiresLoading"),
      setWillLoadEquipment: setProperty("willLoadEquipment"),
      setHasLoadingEquipment: setProperty("hasLoadingEquipment"),
      setLoadingEquipmentDescription: setProperty("loadingEquipmentDescription")
    },
    guards: {
      didSelectLocationDifferentYes: (context, event) => {
        return event.locationDifferent === "yes";
      },
      didSelectLocationDifferentNo: (context, event) => {
        return event.locationDifferent === "no";
      },
      isDescriptionEmpty: guardEmpty("description"),
      isLocationDifferentEmpty: guardEmpty("locationDifferent"),
      isStreetAddressEmpty: (context: any, event: any) => {
        if (context["locationDifferent"] === "yes") {
          return isEmpty(context["streetAddress"]);
        }

        return false;
      },
      isStateEmpty: (context: any, event: any) => {
        if (context["locationDifferent"] === "yes") {
          return isEmpty(context["state"]);
        }

        return false;
      },
      isCityEmpty: (context: any, event: any) => {
        if (context["locationDifferent"] === "yes") {
          return isEmpty(context["city"]);
        }

        return false;
      },
      isPostalCodeEmpty: (context: any, event: any) => {
        if (context["locationDifferent"] === "yes") {
          return isEmpty(context["postalCode"]);
        }

        return false;
      },
      isHasLienEmpty: guardEmpty("hasLien"),
      isLienHolderNameEmpty: (context: any, event: any) => {
        if (context["hasLien"] === "yes") {
          return isEmpty(context["lienHolderName"]);
        }
      },
      isLienHolderContactEmpty: (context: any, event: any) => {
        if (context["hasLien"] === "yes") {
          return isEmpty(context["lienHolderContact"]);
        }
      },
      isRequiresDismantlingEmpty: guardEmpty("requiresDismantling"),
      isDismantleDaysEmpty: (context: any, event: any) => {
        if (context["requiresDismantling"] === "yes") {
          return isEmpty(context["dismantleDays"]);
        }
      },
      isDismantleDaysValid: (context: any, event: any) => {
        if (context["requiesDismantling"] === "yes") {
          return !isNumber(context["dismantleDays"]);
        }
      },
      isWillHelpDismantleEmpty: (context: any, event: any) => {
        if (context["requiresDismantling"] === "yes") {
          return isEmpty(context["willHelpDismantle"]);
        }
      },
      isDismantleHelpDescriptionEmpty: (context: any, event: any) => {
        if (
          context["requiresDismantling"] === "yes" &&
          context["willHelpDismantle"] === "yes"
        ) {
          return isEmpty(context["dismantleHelpDescription"]);
        }
      },
      isProvidesDisconnectEmpty: guardEmpty("providesDisconnect"),
      isRequiresCraneEmpty: (context, event) => {
        if (context["requiresDismantling"] === "yes") {
          return isEmpty(context["requiresCrane"]);
        }
      },
      isNumberOfTrucksEmpty: (context, event) => {
        if (context["requiresLoading"] === "yes") {
          return isEmpty(context["numberOfTrucks"]);
        }
      },
      isNumberOfTrucksValid: (context: any, event: any) => {
        if (context["requiresLoading"] === "yes") {
          return !isNumber(context["numberOfTrucks"]);
        }
      },
      isRequiresLoadingEmpty: guardEmpty("requiresLoading"),
      isWillLoadEquipmentEmpty: (context, event) => {
        if (context["requiresLoading"] === "yes") {
          return isEmpty(context["willLoadEquipment"]);
        }

        return false;
      },
      isHasLoadingEquipmentEmpty: (context, event) => {
        if (
          context["requiresLoading"] === "yes" &&
          context["willLoadEquipment"] === "no"
        ) {
          return isEmpty(context["hasLoadingEquipment"]);
        }

        return false;
      },
      loadingEquipmentDescriptionEmpty: (context, event) => {
        if (
          context["requiresLoading"] === "yes" &&
          context["willLoadEquipment"] === "no" &&
          context["hasLoadingEquipment"] === "yes"
        ) {
          return isEmpty(context["loadingEquipmentDescription"]);
        }

        return false;
      }
    }
  } as any);

  return step4;
};
